// React hook for translations with language change support

import { useState, useEffect } from 'react';
import { t, getCurrentLanguage, setLanguage } from '../utils/translations.js';

export const useTranslation = () => {
  const [currentLang, setCurrentLang] = useState(getCurrentLanguage());
  const [, forceUpdate] = useState({});

  useEffect(() => {
    const handleLanguageChange = (event) => {
      setCurrentLang(event.detail.language);
      // Force re-render
      forceUpdate({});
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    
    return () => {
      window.removeEventListener('languageChanged', handleLanguageChange);
    };
  }, []);

  return {
    t,
    currentLanguage: currentLang,
    setLanguage,
    // Helper function to get translation with interpolation
    translate: (key, fallback, variables = {}) => {
      let translation = t(key, fallback);
      
      // Simple variable interpolation
      Object.keys(variables).forEach(variable => {
        translation = translation.replace(`{{${variable}}}`, variables[variable]);
      });
      
      return translation;
    }
  };
};